import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";

var _dec, _class, _class2;

import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Initialize, GetReady, Required } from '../decorators';
import { PWD_REG_INIT, PWD_REG_MODIFY } from '../constants';
import { UniFlow } from './UniFlow';

/**
 * 邀请注册设置密码
 * @link https://shopline.yuque.com/sczv0i/zbwfmf/ygebf0
 */
export var PwdRegFlow = (_dec = Required(['_stoken']), (_class = (_class2 = /*#__PURE__*/function (_UniFlow) {
  _inherits(PwdRegFlow, _UniFlow);

  var _super = _createSuper(PwdRegFlow);

  function PwdRegFlow() {
    _classCallCheck(this, PwdRegFlow);

    return _super.apply(this, arguments);
  }

  _createClass(PwdRegFlow, [{
    key: "init",
    value:
    /** 初始化 */
    function init(params) {
      return this.request(PWD_REG_INIT, params);
    }
    /** 账号密码登陆 */

  }, {
    key: "modify",
    value: function () {
      var _modify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
        var pwd, secret, finalParams;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                pwd = params.pwd;
                secret = this.encrypt(pwd);
                finalParams = Object.assign(_objectSpread({}, params), {
                  pwd: secret
                });
                return _context.abrupt("return", this.request(PWD_REG_MODIFY, finalParams));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function modify(_x) {
        return _modify.apply(this, arguments);
      }

      return modify;
    }()
  }]);

  return PwdRegFlow;
}(UniFlow), _defineProperty(_class2, "flowName", 'PwdRegFlow'), _class2), (_applyDecoratedDescriptor(_class.prototype, "init", [Initialize], Object.getOwnPropertyDescriptor(_class.prototype, "init"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "modify", [GetReady, _dec], Object.getOwnPropertyDescriptor(_class.prototype, "modify"), _class.prototype)), _class));